const doc = [({"da":({"js":({"admin":({"contacts":({"edit":({"school_content":({"school_information":"Skoleinformation"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;